import './footerButton.scss';

import * as React from 'react';

import { IHistory } from '../../../interfaces';

export interface IChartFooterButtonsProps {
    label: string;
    redirectTo: string;
    history: IHistory;
    onClickFlaggedForms: Function;
    flaggedForms: string;
}

export class ChartFooterButtons extends React.PureComponent<IChartFooterButtonsProps, {}> {
    constructor(props: IChartFooterButtonsProps) {
        super(props);
    }

    render() {
        const { label, redirectTo, history, onClickFlaggedForms, flaggedForms } = this.props;
        return <div style={styles.viewAllFormsButtonContainer as React.CSSProperties} >
            <div
                className="footer-button"
                style={{ display: 'inline-block', margin: '5px 10px' }}
                title={`Click to View all ${label} Forms`}
            >
                <button
                    onClick={() => history.push(`/reports/${redirectTo}`)}
                    style={styles.viewAllFormsButtonStyle}
                >
                    View All {label}  Forms
            </button>
            </div>
            <div style={{ display: 'inline-block', margin: '5px 10px' }}
                title={`Click to View Flagged ${label} Forms`}
            >
                <button
                    onClick={() => onClickFlaggedForms()}
                    style={styles.viewFlaggedForms as React.CSSProperties}
                >
                    Flagged {label} Forms  <span style={styles.flaggedFormCount} >{flaggedForms}</span>
                </button>
            </div>
        </div>;
    }
}

const styles = {
    viewAllFormsButtonStyle: {
        border: 'none',
        padding: '0 15px',
        height: '32px',
        outline: 'none',
        background: '#a4bf43',
        borderRadius: '5px',
    },
    viewAllFormsButtonContainer: {
        position: 'absolute',
        bottom: '4%',
        width: '90%',
        textAlign: 'center',
    },
    viewFlaggedForms: {
        border: 'none',
        paddingLeft: '10px',
        height: '32px',
        outline: 'none',
        background: '#a4bf43',
        position: 'relative',
        borderRadius: '5px',
    },
    flaggedFormCount: {
        height: '100px',
        width: '100px',
        padding: '8px',
        borderLeft: '1px solid',
        marginLeft: '8px'
    }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/reusableComponents/ChartComponents/ChartFooterButtons.tsx